module.exports = "/assets/2b7a3e93d6162a074ee0bf1418ddbbf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4N.png
// module id = 1040
// module chunks = 0